import Select, { MenuPlacement } from 'react-select';
import { useState, forwardRef, useEffect, useImperativeHandle } from 'react';
import classes from './CustomSelect.module.scss';

function CustomSelect(props: ComponentProps, ref: any) {
	const [defaultOptionText] = useState(props.defaultOptionText || 'Válasszon...');
	const [value, setValue] = useState(getValue(props.options, props.value || 'default', defaultOptionText));

	useEffect(() => {
		setValue(getValue(props.options, props.value || 'default', defaultOptionText, props.withoutDefault));
	}, [props.value]);

	useImperativeHandle(ref, () => ({
		getValue: () => value.value,
		setValue: (value: string | null) =>
			setValue(getValue(props.options, value || 'default', defaultOptionText, props.withoutDefault)),
	}));

	const classNames = [classes.Select];
	if (props.required && value.value === 'default') {
		classNames.push(classes.required);
	}
	return (
		<Select
			onChange={(value: any) => {
				if (!value) {
					value = getValue(props.options, props.value, defaultOptionText);
				}
				setValue(value);
				if (props.onChange) {
					props.onChange(value.value);
				}
			}}
			isClearable={props.isClearable}
			options={
				props.withoutDefault
					? props.options
					: [{ value: 'default', label: defaultOptionText }, ...props.options]
			}
			className={classNames.join(' ')}
			value={value}
			isDisabled={props.disabled}
			menuPlacement={props.menuPlacement || 'auto'}
			noOptionsMessage={() => props.noOptionsMessage || 'Nincs találat'}
			menuPosition="fixed"
			menuShouldBlockScroll={true}
		/>
	);
}

function getValue(options: Option[], value: string = 'default', defaultOptionText: string, withoutDefault?: boolean) {
	return (
		options.find((option: any) => option.value === value) ||
		(withoutDefault ? options[0] : { value: 'default', label: defaultOptionText })
	);
}

export default forwardRef(CustomSelect);

interface Option {
	label: string;
	value: string;
}

interface ComponentProps {
	onChange?: Function;
	isClearable?: boolean;
	options: Option[];
	value?: string;
	disabled?: boolean;
	defaultOptionText?: string;
	withoutDefault?: boolean;
	required?: boolean;
	menuPlacement?: MenuPlacement;
	noOptionsMessage?: string;
}
